import { typographyClasses } from '@mui/material'
import Box from '@mui/material/Box'

import Button from 'components/Common/Button'

import { PRIMARY_BUTTON } from 'themes/theme'

const ConnectButton = ({
  label,
  onClick,
  primary = false,
  tooltipPlacement = 'top',
  fullWidth = false,
  isConnected = true,
  ...rest
}) => {
  const buttonSx = { [`.${typographyClasses.root}`]: { fontSize: '12px' } }

  const handleConnectClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Button sx={buttonSx} type={PRIMARY_BUTTON} fullWidth={fullWidth} onClick={handleConnectClick} {...rest}>
        {label}
      </Button>
    </Box>
  )
}

export default ConnectButton
